'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("itColumnSelector", function (itTableRegistry) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    controllerAs: "selectorCtrl",
    template: require("./itColumnSelector.html"),
    link: function link($scope, $el, $attrs, ctrl) {
      if ($attrs.xlsUrl) {
        $scope.xlsUrl = $attrs.xlsUrl;
        // post
        $scope.xlsPostMethod = $attrs.xlsMethod === 'post';
      }
      if ($attrs.docx) {
        $scope.docx = true;
      }
      $attrs.$observe("tableId", function (tableId) {
        var unwatch = $scope.$watch(function () {
          return itTableRegistry.getController(tableId);
        }, function (tableController) {
          if (!tableController) {
            return;
          }
          unwatch();
          ctrl.setTableController(tableController);
        });
      });
    },
    controller: function controller($scope, xlsMetadataService) {
      var ctrl = this,
        tableCtrl = null;
      $scope.menuOpened = false;
      $scope.columnGroups = [];
      $scope.xlsMetadata = function () {
        console.log('xlsMetadata', $scope.xlsUrl, $scope.xlsPostMethod);
        xlsMetadataService.openMetadataPopin($scope.xlsUrl, $scope.xlsPostMethod, null, false, !$scope.docx).then(function () {});
      };
      ctrl.setTableController = function (_tableCtrl) {
        tableCtrl = _tableCtrl;
        $scope.columnGroups = tableCtrl.getColumnGroups(); // TODO : watch ?
        $scope.isResizable = tableCtrl.getConfig() && tableCtrl.getConfig().resizable === true;
        $scope.isReorderable = tableCtrl.getConfig() && tableCtrl.getConfig().reorderable === true;
      };
      $scope.toggleMenu = function () {
        $scope.menuOpened = !$scope.menuOpened;
      };
      $scope.toggleGroup = function (group) {
        tableCtrl.setGroupVisibility(group.id, !$scope.isGroupVisible(group));
      };
      $scope.resetColumnsSize = function () {
        if (tableCtrl && tableCtrl.resetColumnsSize) {
          tableCtrl.resetColumnsSize();
        }
      };
      $scope.resetColumnsOrder = function () {
        if (tableCtrl && tableCtrl.resetColumnsOrder) {
          tableCtrl.resetColumnsOrder();
        }
      };
      $scope.isGroupVisible = function (group) {
        var visibilityMap = tableCtrl.getColumnsVisibility();
        for (var i = 0; i < group.columns.length; i++) {
          if (visibilityMap[group.columns[i]] === false) {
            return false;
          }
        }
        return true;
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/components/itColumnSelector.js
// module id = 2807
// module chunks = 13